import {
  defaultFont,
  primaryBoxShadow
} from '../../../../assets/jss/material-dashboard-pro-react.jsx'

export default {
  consent: {
    ...defaultFont,
    backgroundColor: '#FFFFFF',
    minHeight: '26px',
    color: 'black',
    lineHeight: '26px',
    padding: '8px 0 8px 30px',
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: '9999'
  },
  consent_a: {
    color: '#00acc1 !important',
    textDecoration: 'none',
    marginLeft: '0.5rem'

  },
  closeConsent: {
    float: 'right',
    display: 'inline-block',
    cursor: 'pointer',
    height: '20px',
    width: '20px',
    margin: '-15px 0 0 0',
    fontWeight: 'bold'

  },

  consent_a_consentOK: {
    backgroundColor: '#00acc1',
    color: '#FFF !important',
    display: 'inline-block',
    borderRadius: '5px',
    padding: '0 20px',
    cursor: 'pointer',
    float: 'right',
    margin: '0 60px 0 10px',
    '&:hover': {
      ...primaryBoxShadow
    }
  }

}
